import { Box, styled } from '@mui/material'
import HomeDatasetsContent from './HomeDatasetsContent'
import HomeDatasetsHeader from './HomeDatasetsHeader'
import Loader from 'features/common/ui/utils/Loader'
import { useRecentResources } from 'features/connections/hooks/connectionsHooks'
import EmptyState from 'features/common/ui/utils/EmptyState'
import DataExplorerIcon from 'assets/icons/icon-products-data-explorer.svg?react'
import { FormattedMessage } from 'react-intl'

const EmptyStateWrapper = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  display: 'flex',
  justifyContent: 'center'
}))

const DataExplorerIconStyled = styled(DataExplorerIcon)(({ theme }) => ({
  '& > path': {
    fill: theme.palette.text.disabled
  }
}))

const EmptyStateContainer = styled(Box)(({ theme }) => ({
  width: theme.spacing(50)
}))

export function HomeDatasets({
  titleId,
  withExploreButton = true,
  withImportButton = true,
  maxDatasets
}: {
  titleId?: string
  withExploreButton?: boolean
  withImportButton?: boolean
  maxDatasets?: number
}) {
  const { data: recentDatasets, isLoading } = useRecentResources(maxDatasets)
  if (!recentDatasets || recentDatasets.length === 0)
    return (
      <EmptyStateWrapper>
        <EmptyStateContainer>
          <EmptyState
            viewBox="0 0 24 24"
            icon={DataExplorerIconStyled}
            caption={<FormattedMessage id="home.datasets.emptyTitle" />}
            content={<FormattedMessage id="home.datasets.emptyContent" />}
          />
        </EmptyStateContainer>
      </EmptyStateWrapper>
    )

  return (
    <Box mb={8}>
      <HomeDatasetsHeader titleId={titleId} withExploreButton={withExploreButton} />
      {isLoading ? (
        <Loader />
      ) : (
        <HomeDatasetsContent datasets={recentDatasets} withImportButton={withImportButton} maxDatasets={maxDatasets} />
      )}
    </Box>
  )
}

export default HomeDatasets
